export const isProtected = (route) => {
  let unprotectedRoutes = [
    '/login','/login/success'
  ];

  return !unprotectedRoutes.includes(route);
}